import { ProfilePage } from "../../profile";

export default function AdminProfilePage(){
     return <ProfilePage></ProfilePage>
}